import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { 
  Play, 
  Square, 
  ZoomIn, 
  ZoomOut,
  RotateCcw,
  Navigation,
  Compass
} from 'lucide-react';

export function ControlPanel({ 
  onStartTour, 
  onStopTour, 
  onZoomIn, 
  onZoomOut,
  sweeps,
  currentSweep 
}) {
  const [tourActive, setTourActive] = useState(false);

  const handleTourToggle = () => {
    if (tourActive) {
      onStopTour();
    } else {
      onStartTour();
    }
    setTourActive(!tourActive);
  };

  return (
    <TooltipProvider delayDuration={300}>
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10">
        <div className="glass rounded-2xl p-2 flex items-center gap-1 shadow-elevated">
          {/* Tour Controls */}
          <div className="flex items-center gap-1 pr-2 border-r border-border/50">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant={tourActive ? "glow" : "icon"}
                  size="icon"
                  onClick={handleTourToggle}
                  className="rounded-xl"
                >
                  {tourActive ? (
                    <Square className="h-4 w-4" />
                  ) : (
                    <Play className="h-4 w-4" />
                  )}
                </Button>
              </TooltipTrigger>
              <TooltipContent side="top">
                <p>{tourActive ? 'Stop Tour' : 'Start Tour'}</p>
              </TooltipContent>
            </Tooltip>
          </div>

          {/* Zoom Controls */}
          <div className="flex items-center gap-1 px-2 border-r border-border/50">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="icon"
                  size="icon"
                  onClick={onZoomIn}
                  className="rounded-xl"
                >
                  <ZoomIn className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent side="top">
                <p>Zoom In</p>
              </TooltipContent>
            </Tooltip>

            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="icon"
                  size="icon"
                  onClick={onZoomOut}
                  className="rounded-xl"
                >
                  <ZoomOut className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent side="top">
                <p>Zoom Out</p>
              </TooltipContent>
            </Tooltip>
          </div>

          {/* Navigation Info */}
          <div className="flex items-center gap-2 pl-2">
            <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
              <Navigation className="h-3.5 w-3.5 text-primary" />
              <span className="font-mono">
                {sweeps?.length || 0} positions
              </span>
            </div>
            {currentSweep?.id && (
              <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                <Compass className="h-3.5 w-3.5 text-accent-foreground" />
                <span className="font-mono truncate max-w-[80px]">
                  {currentSweep.id.substring(0, 8)}...
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}

export default ControlPanel;
